module.exports = __webpack_public_path__ + "img/container_lamp.9971ce32.svg";